(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  // ng-show가 true가 되기 전까지는 rendering을 하지 않도록 하기 위해 사용
  // 초기 상태에서는 ng-if="false" 였다가,
  // 한번 shown이 되면(ng-show=true), 이후로는 ng-if="true" 와 같이 동작한다.
  m.directive('vvIfShown', ['ngIfDirective', function(ngIfDirective) {
    var ngIf = ngIfDirective[0];
    var res = {
      multiElement: ngIf.multiElement,
      transclude: ngIf.transclude,
      priority: ngIf.priority - 1,
      terminal: ngIf.terminal,
      restrict: ngIf.restrict,
      $$tlb: true,
      link: function (scope, element, attrs) {
        var shown = false;
        var initialNgIf = attrs.ngIf, ifEvaluator;

        attrs.$observe('ngShow', function (ngShow) {
          var funcDereg = scope.$watch(ngShow, function (value) {
            shown = shown || value;
            if (shown)
            funcDereg();
          });
        });

        if (initialNgIf) {
          ifEvaluator = function () { return scope.$eval(initialNgIf) || shown; };
        } else {
          ifEvaluator = function () { return shown; };
        }
        attrs.ngIf = ifEvaluator;
        ngIf.link.apply(ngIf, arguments);
      }
    };

    return res;
  }]);
})(window, window.angular);
